import { BlogPostApi, StartPageTileApi } from "../openapi";
import openApiConfig from "./http_service";

const blogPostApi=new BlogPostApi(openApiConfig)

export default blogPostApi